module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showModal) ? _c('modal', {
    on: {
      "close": _vm.close
    }
  }, [(_vm.propIsLoading) ? _c('template', {
    slot: "body"
  }, [_c('Loader', {
    attrs: {
      "bg-color": "#f6f9fc"
    }
  })], 1) : _c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "add-lesson__header",
    style: ({
      'backgroundColor': _vm.color ? _vm.color : '#fff'
    })
  }, [_c('h2', [_vm._v(_vm._s(_vm.name.length > 0 ? _vm.name : !_vm.isActivities ? _vm.i18n[_vm.locale]['create_subject'] : 'Opret aktivitet'))]), _vm._v(" "), _c('div', {
    staticClass: "add-lesson__calendars"
  }, [_vm._v("\n          " + _vm._s(_vm.showMasterCalendarName) + "\n        ")]), _vm._v(" "), (_vm.activeTab === 'edit' && !_vm.isActivities && _vm.canSeeTaskOverviewToggle) ? _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: false,
        animateFill: false,
        animation: 'shift-away',
        zIndex: '999999992',
        boundary: 'window'
      }),
      expression: "{\n               arrow: false,\n               animateFill: false,\n               animation: 'shift-away',\n               zIndex: '999999992',\n               boundary: 'window'}"
    }],
    staticClass: "add-lesson__header__task-overview",
    attrs: {
      "content": _vm.i18n[_vm.locale]['show_on_task_overview_desc']
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleTaskOverview.apply(null, arguments)
      }
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_on_task_overview']))]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "propOn": _vm.taskOverview,
      "allowChanges": false
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editSubject && !_vm.isActivities) ? _c('div', {
    staticClass: "add-lesson__header__tabs"
  }, [_c('div', {
    staticClass: "add-lesson__header__tabs__tab",
    class: {
      'tab--is-active': _vm.activeTab === 'edit'
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'edit'
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale].edit_subject) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "add-lesson__header__tabs__tab",
    class: {
      'tab--is-active': _vm.activeTab === 'history'
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'history'
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale].activity) + "\n          ")]), _vm._v(" "), (_vm.isShowSubjectsPools) ? _c('div', {
    staticClass: "add-lesson__header__tabs__tab",
    class: {
      'tab--is-active': _vm.activeTab === 'calendarHours'
    },
    on: {
      "click": _vm.onClickCalendarHoursTab
    }
  }, [_vm._v("\n            Puljer\n          ")]) : _vm._e(), _vm._v(" "), (_vm.isReductionsActive && _vm.isShowReductions) ? _c('div', {
    staticClass: "add-lesson__header__tabs__tab",
    class: {
      'tab--is-active': _vm.activeTab === 'reductions'
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'reductions'
      }
    }
  }, [_vm._v("\n            Reduktioner\n          ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "add-lesson__form"
  }, [(_vm.activeTab === 'history') ? _c('div', {
    staticClass: "add-lesson__form__content"
  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale].latest_activity))]), _vm._v(" "), _c('SubjectFormLog', {
    attrs: {
      "subject": _vm.editSubject
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'reductions') ? _c('div', {
    staticClass: "add-lesson__form__content"
  }, [_c('h2', [_vm._v("Reduktioner")]), _vm._v(" "), _c('SubjectFormReductions', {
    attrs: {
      "subject": _vm.editSubject
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'calendarHours') ? _c('div', {
    staticClass: "add-lesson__form__content"
  }, [_c('SubjectFormCalendarHours', {
    attrs: {
      "subject": _vm.editSubject
    },
    on: {
      "subjectHoursSaved": _vm.onSubjectHoursSaved
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'edit') ? _c('div', {
    staticClass: "add-lesson__form__content"
  }, [(_vm.editSubject) ? [(_vm.isShowSubjectsRequest && _vm.subjectRequestedBy) ? _c('div', {
    staticClass: "subjects-requested-by do-warning"
  }, [_c('label', {
    staticClass: "do-label"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['requested_by']))]), _vm._v(" " + _vm._s(_vm.subjectRequestedBy) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.editSubject && _vm.showDanishPreparationFactorBesideHours && !_vm.isDanishPrepBinaryOnOwnRow) ? [_c('div', {
    staticClass: "input-group input-group__flex"
  }, [_c('div', {
    staticClass: "flex-"
  }, [_c('label', [_vm._v(_vm._s(_vm.hoursLabel))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: (_vm.hoursDisabledTippy),
      expression: "hoursDisabledTippy"
    }],
    attrs: {
      "content": _vm.i18n[_vm.locale]['hours_disabled_desc']
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.hours),
      expression: "hours",
      modifiers: {
        "number": true
      }
    }],
    ref: "inputLessonCount",
    staticClass: "do-input",
    class: {
      'input--error': _vm.formErrors['hours'],
      'input--disabled': _vm.isHoursDisabled
    },
    attrs: {
      "type": "number",
      "disabled": _vm.isHoursDisabled
    },
    domProps: {
      "value": (_vm.hours)
    },
    on: {
      "focus": function($event) {
        return _vm.selectAllOnFocus($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hours = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.formErrors['hours']) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v(_vm._s(_vm.formErrors['hours'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), _c('DkPreparationFactorControl', {
    attrs: {
      "subject-type": _vm.subjectType,
      "school-prep-factor": _vm.schoolSettings.prepFactor,
      "labels": _vm.danishPreparationControlLabels,
      "wrap-class": "flex-1"
    },
    model: {
      value: (_vm.preparation),
      callback: function($$v) {
        _vm.preparation = $$v
      },
      expression: "preparation"
    }
  })], 1)] : (_vm.editSubject && _vm.showDanishPreparationFactorBesideHours && _vm.isDanishPrepBinaryOnOwnRow) ? [_c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.hoursLabel))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: (_vm.hoursDisabledTippy),
      expression: "hoursDisabledTippy"
    }],
    attrs: {
      "content": _vm.i18n[_vm.locale]['hours_disabled_desc']
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.hours),
      expression: "hours",
      modifiers: {
        "number": true
      }
    }],
    ref: "inputLessonCount",
    staticClass: "do-input",
    class: {
      'input--error': _vm.formErrors['hours'],
      'input--disabled': _vm.isHoursDisabled
    },
    attrs: {
      "type": "number",
      "disabled": _vm.isHoursDisabled
    },
    domProps: {
      "value": (_vm.hours)
    },
    on: {
      "focus": function($event) {
        return _vm.selectAllOnFocus($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hours = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.formErrors['hours']) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v(_vm._s(_vm.formErrors['hours'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('DkPreparationFactorControl', {
    attrs: {
      "subject-type": _vm.subjectType,
      "school-prep-factor": _vm.schoolSettings.prepFactor,
      "labels": _vm.danishPreparationControlLabels,
      "wrap-class": "input-group dk-prep-factor-full-width"
    },
    model: {
      value: (_vm.preparation),
      callback: function($$v) {
        _vm.preparation = $$v
      },
      expression: "preparation"
    }
  })], 1)] : (_vm.editSubject) ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.hoursLabel))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: (_vm.hoursDisabledTippy),
      expression: "hoursDisabledTippy"
    }],
    attrs: {
      "content": _vm.i18n[_vm.locale]['hours_disabled_desc']
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.hours),
      expression: "hours",
      modifiers: {
        "number": true
      }
    }],
    ref: "inputLessonCount",
    staticClass: "do-input",
    class: {
      'input--error': _vm.formErrors['hours'],
      'input--disabled': _vm.isHoursDisabled
    },
    attrs: {
      "type": "number",
      "disabled": _vm.isHoursDisabled
    },
    domProps: {
      "value": (_vm.hours)
    },
    on: {
      "focus": function($event) {
        return _vm.selectAllOnFocus($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hours = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.formErrors['hours']) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v(_vm._s(_vm.formErrors['hours'][_vm.locale]))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.calendarType !== 'user') ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_c('span', {
    staticClass: "icon-user"
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_teacher']))]), _vm._v(" "), _c('DSelectCalendarIds', {
    attrs: {
      "itemType": "USER",
      "showTags": true,
      "preSelectedItems": _vm.userCalendarIds,
      "sortSelectedByName": true
    },
    on: {
      "update": _vm.setSelectedUsers
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_c('span', {
    staticClass: "icon-location"
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_room']))]), _vm._v(" "), _c('DSelectCalendarIds', {
    attrs: {
      "itemType": "ROOM",
      "preSelectedItems": _vm.roomCalendarIds
    },
    on: {
      "update": _vm.setSelectedRooms
    }
  })], 1), _vm._v(" "), (!_vm.isPossibleToAddKlasses && _vm.isAllowedToAddKlasses) ? _c('p', {
    staticClass: "text-link",
    on: {
      "click": function($event) {
        _vm.isPossibleToAddKlasses = true
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['add_klass']) + "?")]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "dropdown"
    }
  }, [(_vm.isPossibleToAddKlasses) ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_c('span', {
    staticClass: "icon-calendar4"
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['add_klass']))]), _vm._v(" "), _c('DSelectCalendarIds', {
    attrs: {
      "itemType": "klass",
      "calendarId": _vm.calendarId,
      "showTags": true,
      "preSelectedItems": _vm.klassCalendarIds,
      "showCreateButton": false
    },
    on: {
      "update": _vm.setSelectedKlass
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "date-toggle"
  }, [_c('div', {
    staticClass: "date-toggle__inner",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleDateFields.apply(null, arguments)
      }
    }
  }, [_c('AppToggle', {
    attrs: {
      "propOn": _vm.isShowDateFields,
      "allowChanges": false
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['show_dates_on_overview']))])], 1)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "dropdown"
    }
  }, [(_vm.isShowDateFields) ? _c('div', {
    staticClass: "input-group__flex"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['from_date']))]), _vm._v(" "), _c('div', {
    staticClass: "date-field"
  }, [_c('DateSelector', {
    attrs: {
      "date": _vm.fromDate || _vm.today,
      "width100": true
    },
    on: {
      "changed": _vm.setFromDate
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['to_date']))]), _vm._v(" "), _c('div', {
    staticClass: "date-field"
  }, [_c('DateSelector', {
    attrs: {
      "date": _vm.toDate || _vm.today,
      "width100": true
    },
    on: {
      "changed": _vm.setToDate
    }
  })], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('p', {
    staticClass: "text-blue advanced-settings__link",
    on: {
      "click": function($event) {
        _vm.isEditSubjectAdvanced = !_vm.isEditSubjectAdvanced
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale]['more_settings']) + "\n              ")])])] : _vm._e(), _vm._v(" "), (!_vm.editSubject || _vm.isEditSubjectAdvanced) ? [_c('div', {
    staticClass: "input-group__flex"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['subject_title']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    ref: "name",
    staticClass: "do-input",
    class: {
      'input--error': _vm.formErrors['name']
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.isActivities ? 'Eks. Motionsdag' : _vm.i18n[_vm.locale]['ex_subject']
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "keyup": function($event) {
        return _vm.removeErrors('name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formErrors['name']) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v(_vm._s(_vm.formErrors['name'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), (_vm.isShowNorwegianPreparationDropdown) ? _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "max-width": "100px"
    }
  }, [_c('label', [_vm._v("Årsramme")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.preparation),
      expression: "preparation",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "d-input__select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.preparation = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.preparationOptionsForNorway), function(prep) {
    return _c('option', {
      key: prep
    }, [_vm._v("\n                    " + _vm._s(prep) + "\n                  ")])
  }), 0)]) : (_vm.showDanishPreparationFactorInTitleRow && !_vm.isDanishPrepBinaryOnOwnRow) ? _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "max-width": "160px"
    }
  }, [_c('DkPreparationFactorControl', {
    attrs: {
      "subject-type": _vm.subjectType,
      "school-prep-factor": _vm.schoolSettings.prepFactor,
      "labels": _vm.danishPreparationControlLabels
    },
    model: {
      value: (_vm.preparation),
      callback: function($$v) {
        _vm.preparation = $$v
      },
      expression: "preparation"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group input-group__subject-codes",
    staticStyle: {
      "max-width": "100px"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['subject_code']))]), _vm._v(" "), (_vm.isSchoolFromDenmark) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.subjectCode),
      expression: "subjectCode",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "d-input__select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.subjectCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }), _vm._v(" "), _vm._l((_vm.standardSubjectCodes), function(subject) {
    return _c('option', {
      key: subject.subject_code,
      domProps: {
        "value": subject.subject_code
      }
    }, [_vm._v("\n                  " + _vm._s(subject.fagkode) + " - " + _vm._s(subject.name) + "\n                ")])
  })], 2) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.subjectCode),
      expression: "subjectCode",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "do-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.subjectCode)
    },
    on: {
      "focus": function($event) {
        return _vm.selectAllOnFocus($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subjectCode = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), (_vm.showDanishPreparationFactorInTitleRow && _vm.isDanishPrepBinaryOnOwnRow) ? _c('div', {
    staticClass: "input-group"
  }, [_c('DkPreparationFactorControl', {
    attrs: {
      "subject-type": _vm.subjectType,
      "school-prep-factor": _vm.schoolSettings.prepFactor,
      "labels": _vm.danishPreparationControlLabels,
      "wrap-class": "input-group dk-prep-factor-full-width"
    },
    model: {
      value: (_vm.preparation),
      callback: function($$v) {
        _vm.preparation = $$v
      },
      expression: "preparation"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.editSubject && !_vm.isEditSubjectAdvanced) ? _c('div', {
    staticClass: "input-group input-group__flex"
  }, [_c('div', {
    staticClass: "flex-"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['hours_in_school_year']))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: (_vm.hoursDisabledTippy),
      expression: "hoursDisabledTippy"
    }],
    attrs: {
      "content": _vm.i18n[_vm.locale]['hours_disabled_desc']
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.hours),
      expression: "hours",
      modifiers: {
        "number": true
      }
    }],
    ref: "inputLessonCount",
    staticClass: "do-input",
    class: {
      'input--error': _vm.formErrors['hours'],
      'input--disabled': _vm.isHoursDisabled
    },
    attrs: {
      "type": "number",
      "disabled": _vm.isHoursDisabled
    },
    domProps: {
      "value": (_vm.hours)
    },
    on: {
      "focus": function($event) {
        return _vm.selectAllOnFocus($event)
      },
      "blur": [function($event) {
        return _vm.removeErrors('hours')
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hours = _vm._n($event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.formErrors['hours']) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v(_vm._s(_vm.formErrors['hours'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), (_vm.showDanishPreparationFactorBesideHours && !_vm.isDanishPrepBinaryOnOwnRow) ? _c('DkPreparationFactorControl', {
    attrs: {
      "subject-type": _vm.subjectType,
      "school-prep-factor": _vm.schoolSettings.prepFactor,
      "labels": _vm.danishPreparationControlLabels,
      "wrap-class": "flex-1"
    },
    model: {
      value: (_vm.preparation),
      callback: function($$v) {
        _vm.preparation = $$v
      },
      expression: "preparation"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-1"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['standard_duration']))]), _vm._v(" "), _c('div', {
    staticClass: "input-group--flex"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.defaultDuration),
      expression: "defaultDuration"
    }],
    ref: "input_default_duration",
    staticClass: "do-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.defaultDuration)
    },
    on: {
      "focus": function($event) {
        return _vm.selectAllOnFocus($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.defaultDuration = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formErrors['defaultDuration']) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v(_vm._s(_vm.formErrors['defaultDuration'][_vm.locale]))]) : _vm._e()]), _vm._v(" "), (_vm.userCanManageSchool) ? _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true
      }),
      expression: "{\n          arrow: true\n        }"
    }],
    staticClass: "input-group--flex__setting-icon",
    attrs: {
      "content": _vm.$t('vue2.set_standard_duration.set_standard_duration_for_the_school')
    }
  }, [_c('div', {
    staticClass: "icon__bg-circle",
    on: {
      "click": function($event) {
        _vm.isOpenDurationModal = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-wrench"
  })])]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), (!_vm.editSubject && !_vm.isEditSubjectAdvanced && _vm.showDanishPreparationFactorBesideHours && _vm.isDanishPrepBinaryOnOwnRow) ? _c('div', {
    staticClass: "input-group"
  }, [_c('DkPreparationFactorControl', {
    attrs: {
      "subject-type": _vm.subjectType,
      "school-prep-factor": _vm.schoolSettings.prepFactor,
      "labels": _vm.danishPreparationControlLabels,
      "wrap-class": "input-group dk-prep-factor-full-width"
    },
    model: {
      value: (_vm.preparation),
      callback: function($$v) {
        _vm.preparation = $$v
      },
      expression: "preparation"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.calendarId) ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_class']))]), _vm._v(" "), _c('DSelectKlass', {
    on: {
      "add": _vm.addKlass,
      "remove": _vm.removeKlass
    }
  }), _vm._v(" "), (_vm.formErrors['calendarId']) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v(_vm._s(_vm.formErrors['calendarId'][_vm.locale]))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_color']))]), _vm._v(" "), _c('ColorPicker', {
    attrs: {
      "initialColor": _vm.color
    },
    on: {
      "changedColor": _vm.setSubjectColor
    }
  })], 1), _vm._v(" "), (!_vm.isActivities) ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_subject_type']))]), _vm._v(" "), _c('SubjectTypePicker', {
    attrs: {
      "calendarType": _vm.calendarType,
      "subjectType": _vm.subjectType,
      "showActivities": _vm.showActivities
    },
    on: {
      "change": _vm.selectSubjectType
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.editSubject) ? _c('div', {
    staticClass: "edit-subject add-lesson__footer"
  }, [_c('div', {
    staticClass: "input-group input-group__submit"
  }, [_c('div', {
    staticClass: "input-group__submit__left"
  }, [(_vm.editSubjectCanBeDeleted) ? _c('button', {
    staticClass: "hint--right bttn--warning",
    attrs: {
      "aria-label": _vm.i18n[_vm.locale]['delete_subject']
    },
    on: {
      "click": _vm.deleteEditSubject
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  })]) : _c('div', {
    staticClass: "hint--right",
    attrs: {
      "aria-label": _vm.i18n[_vm.locale]['cannot_delete']
    }
  }, [_c('button', {
    staticClass: "bttn bttn--disabled"
  }, [_c('span', {
    staticClass: "icon-bin"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group__submit__right"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel']))]), _vm._v(" "), (_vm.editSubject) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.updateSubject
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['update_subject']) + "\n                ")]) : _vm._e()])])]) : _c('div', {
    staticClass: "input-group input-group__submit add-lesson__footer"
  }, [_c('div', {
    staticClass: "input-group__submit__left"
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group__submit__right"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['cancel']))]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.createSubject
    }
  }, [_vm._v("\n                " + _vm._s(!_vm.isActivities ? _vm.i18n[_vm.locale]['create_subject'] : 'Opret aktivitet') + "\n              ")])])])], 2) : _vm._e()])])], 2) : _vm._e(), _vm._v(" "), _c('StandardDurationSetting', {
    attrs: {
      "isOpenModal": _vm.isOpenDurationModal
    },
    on: {
      "close": function($event) {
        _vm.isOpenDurationModal = false
      },
      "submit": _vm.saveUpdatedDuration
    }
  }), _vm._v(" "), (_vm.subjectsWithSameName.length > 0) ? _c('SubjectFormDeleteSubjects', {
    attrs: {
      "subjectsWithSameName": _vm.subjectsWithSameName
    },
    on: {
      "close": _vm.closeModalSubjectsWithSameName,
      "keep": _vm.keepExistingSubjects,
      "delete": _vm.deleteExistingSubjects
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPoolsConfirm) ? _c('SubjectPoolsUpdateConfirm', {
    attrs: {
      "subject": _vm.editSubject,
      "newHours": _vm.hours
    },
    on: {
      "updateAll": _vm.onPoolsConfirmUpdateAll,
      "subjectOnly": _vm.onPoolsConfirmSubjectOnly,
      "close": _vm.onPoolsConfirmClose
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showAssignTeacherToEventsConfirm) ? _c('SubjectAssignTeacherToEventsConfirm', {
    attrs: {
      "teacherNames": _vm.assignTeacherToEventsNames,
      "initialDate": _vm.assignTeacherToEventsInitialDate,
      "mode": _vm.assignTeacherToEventsAction,
      "calendarKind": _vm.assignTeacherToEventsKind,
      "color": _vm.color,
      "subjectName": _vm.name
    },
    on: {
      "confirm": _vm.onAssignTeacherToEventsConfirm,
      "skip": _vm.onAssignTeacherToEventsSkip
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c586aff!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subjects/SubjectForm.vue
// module id = 1757
// module chunks = 1